<template>

  <SideComponent class="ni-page-side" show-sidebar-login @scrollto="scroll" />



  <Login2

    :show-dialog="showDialog"

    :show-login="showLogin"

    :show-mobile="showMobile"

    @update:show-dialog="onLoginDialogChange"

  />



  <div ref="pageRoot" class="ni-page">

    <div id="home" class="ni-page__top-anchor" aria-hidden="true"></div>

    <NewIndexHeader

      :is-logged-in="isLoggedIn"

      @search="handleSearch"

      @login="openLogin"

    />



    <main class="ni-page__main">

      <NewsCarousel :news-list="pageData.newsList" />

      <SloganSlider :scenes="pageData.sloganScenes" />

      <SpotsGrid :spot-cards="pageData.spotCards" />

      <IntCommunicator
        :cates="pageData.internationalCates"
        :items="pageData.internationalItems"
      />

      <PhotoDepot

        :hot-photos="pageData.hotPhotos"

        :subject-cats="pageData.subjectCats"

        :daily-scene="pageData.dailyScene"

        :weekly-pick="pageData.weeklyPick"

      />

      <VisualQingdao :videos="pageData.visualVideos" />

      <QdRelease :release-cards="pageData.releaseCards" />

      <VrExhibition :vr-list="pageData.vrList" />

      <AskQingdao />

    </main>



    <Footer />

  </div>

</template>



<script>

import newIndex from './new_index_controller';

export default newIndex;

</script>



<style src="@/assets/css/new_index_tokens.css"></style>

<style src="@/assets/css/new_index.css"></style>


